export default __webpack_public_path__ + "static/media/checkmark.eaecc3bb.svg";